export const getDirectoryLabel = (type: string) => {
  switch (type) {
    case "railways":
      return "Дороги";
    case "stations":
      return "Станции ЖД";
    case "etsngs":
      return "Коды ЕТСНГ";
    case "wagonModels":
      return "Модели ПС";
    default:
      return type;
  }
};
